export const categoryDropDown = [
    {
        key: "men",
        label: "Men",
        color: "text-blue-800",
        sections: [
            {
                label: "Topwear",
                children: [
                    { label: "T-shirts", slug: "men-t-shirts" },
                    { label: "Casual shirts", slug: "men-casual-shirts" },
                    { label: "Formal shirts", slug: "men-formal-shirts" },
                    { label: "Sweatshirts", slug: "men-sweatshirts" },
                    { label: "Sweaters", slug: "men-sweaters" },
                    { label: "Jackets", slug: "men-jackets" }
                ]
            },
            {
                label: "Bottomwear",
                children: [
                    { label: "Jeans", slug: "men-jeans" },
                    { label: "Casual trousers", slug: "men-casual-trousers" },
                    { label: "Formal trousers", slug: "men-formal-trousers" },
                    { label: "Shorts", slug: "men-shorts" },
                    { label: "Track Pants & Joggers", slug: "men-track-pants-and-joggers" },
                    { label: "Boxers", slug: "men-boxers" },
                    { label: "Vests", slug: "men-vests" }
                ]
            },
            {
                label: "Footwear",
                children: [
                    { label: "Casual Shoes", slug: "men-casual-shoes" },
                    { label: "Formal Shoes", slug: "men-formal-shoes" },
                    { label: "Sports Shoes", slug: "men-sports-shoes" },
                    { label: "Sneakers", slug: "men-sneakers" },
                    { label: "Sandals & Floaters", slug: "men-sandals-and-floaters" },
                    { label: "Flip Flops", slug: "men-flip-flops" },
                    { label: "Socks", slug: "men-socks" }
                ]
            }
        ]
    },
    {
        key: "women",
        label: "Women",
        color: "text-red-600",
        sections: [
            {
                label: "Indian & Fusion Wear",
                children: [
                    { label: "Kurtas & Suits", slug: "women-kurtas-and-suits" },
                    { label: "Sarees", slug: "women-sarees" },
                    { label: "Ethnic wear", slug: "women-ethnic-wear" },
                    { label: "Leggings & Churidars", slug: "women-leggings-and-churidars" },
                    { label: "Skirts & Palazzos", slug: "women-skirts-and-palazzos" },
                    { label: "Dress Materials", slug: "women-dress-materials" },
                    { label: "Lehenga", slug: "women-lehenga" }
                ]
            },
            {
                label: "Western Wear",
                children: [
                    { label: "Dresses", slug: "women-dresses" },
                    { label: "Tops", slug: "women-tops" },
                    { label: "T-shirts", slug: "women-t-shirts" },
                    { label: "Jeans", slug: "women-jeans" },
                    { label: "Trousers", slug: "women-trousers" },
                    { label: "Shorts & Skirts", slug: "women-shorts-and-skirts" },
                    { label: "Jumpsuits", slug: "women-jumpsuits" },
                    { label: "Co-ords", slug: "women-co-ords" }
                ]
            },
            {
                label: "Footwear",
                children: [
                    { label: "Casual Shoes", slug: "women-casual-shoes" },
                    { label: "Sports Shoes", slug: "women-sports-shoes" },
                    { label: "Formal Shoes", slug: "women-formal-shoes" },
                    { label: "Flats", slug: "women-flats" },
                    { label: "Heels", slug: "women-heels" },
                    { label: "Boots", slug: "women-boots" },
                    { label: "Socks", slug: "women-socks" }
                ]
            }
        ]
    },
    {
        key: "electronics",
        label: "Electronics",
        color: "text-green-600",
        sections: [
            {
                label: "Cameras",
                children: [
                    { label: "DSLR & Mirrorless", slug: "electronics-dslr-and-mirrorless" },
                    { label: "Instant cameras", slug: "electronics-instant-cameras" },
                    { label: "Camera tripods", slug: "electronics-camera-tripods" },
                    { label: "Camera lenses", slug: "electronics-camera-lenses" },
                    { label: "Drones", slug: "electronics-drones" },
                    { label: "Binoculars", slug: "electronics-binoculars" }
                ]
            },
            {
                label: "Laptops & Accessories",
                children: [
                    { label: "Laptops", slug: "electronics-laptops" },
                    { label: "Mouse", slug: "electronics-mouse" },
                    { label: "Keyboards", slug: "electronics-keyboards" },
                    { label: "USB Gadgets", slug: "electronics-usb-gadgets" }
                ]
            }
        ]
    }
];
